import { featuredMovies } from '@/mocks/movies';

const stats = [
  { value: '32,000+', label: '收录影片' },
  { value: '86', label: '今日更新' },
  { value: '6,200', label: '高清专区' },
  { value: '18', label: '题材分类' },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20dark%20theater%20atmosphere%2C%20soft%20red%20curtain%20bokeh%20and%20golden%20projector%20light%20beams%2C%20warm%20amber%20and%20deep%20crimson%20glow%2C%20elegant%20film%20festival%20backdrop%2C%20grain%20texture%2C%20no%20text%20no%20people&width=1920&height=1080&seq=wsr-hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/92"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-36 pb-14 md:pb-20">
        <div className="max-w-3xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs md:text-sm">
            <i className="ri-movie-2-line text-accent-300"></i>
            最新电影资源 · 电影大全 · 高清电影
          </span>
          <h1 className="mt-6 font-heading font-bold text-3xl md:text-5xl leading-tight text-background-50">
            西瓜影院最新电影资源
            <br className="hidden md:block" />
            今日更新与热门影片一站看齐
          </h1>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200/85 max-w-2xl mx-auto">
            为你整理西瓜影院最新电影资源，涵盖电影大全、高清电影、今日更新和热门影片。
            无论你想看新片还是经典，都能快速找到播放入口，享受流畅观影体验。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#today"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-flashlight-fill"></i>
              查看今日更新
            </a>
            <a
              href="#genres"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-layout-grid-line"></i>
              浏览电影大全
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto animate-fade-in">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/10 border border-background-50/15 px-4 py-4 text-center backdrop-blur-sm"
            >
              <div className="font-heading font-bold text-xl md:text-2xl text-accent-300">{s.value}</div>
              <div className="mt-1 text-xs md:text-sm text-background-200/80">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredMovies.map((item) => (
            <a
              key={item.id}
              href="#hot"
              className="group relative rounded-lg overflow-hidden h-64 md:h-72 block border border-background-50/10"
            >
              <img
                src={item.cover}
                alt={`${item.title} 影片封面，${item.genres}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-transparent"></div>
              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className="px-2 py-1 rounded-md bg-accent-500 text-accent-950 text-xs font-medium">
                  {item.quality}
                </span>
                <span className="px-2 py-1 rounded-md bg-background-50/15 text-background-50 text-xs">
                  {item.rating} 分
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-heading font-bold text-xl text-background-50">{item.title}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-background-200/85 leading-relaxed line-clamp-2">
                  {item.tagline}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-300">
                  {item.genres}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}